import { Component } from '@angular/core';
import { ModalChangePasswordService } from './modal-change-password.service';

@Component({
  selector: 'app-modal-change-password',
  templateUrl: './modal-change-password.component.html',
  styleUrl: './modal-change-password.component.css'
})
export class ModalChangePasswordComponent {

  showModal = false;

  constructor(private modalService: ModalChangePasswordService) {}

  ngOnInit(): void {
    // Subscribe to modal state changes
    this.modalService.modalState$.subscribe(state => {
      this.showModal = state;

      if (state) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    });
  }

  /**
   * Close the modal
   */
  closeModal(): void {
    this.modalService.closeModal();
  }

  /**
   * Stop event propagation when clicking on modal content
   */
  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

}
